import React from 'react';
import { Box, Button, MenuItem, Paper, TextField, Typography } from '@mui/material';

const QUICK_ACTIONS = [
  { key: 'forceLive', label: 'Force Live' },
  { key: 'forcePopcornParentLive', label: 'Force Popcorn Parent Live' },
  { key: 'forceSecondaryPricing', label: 'Force Secondary Pricing' },
  { key: 'forceCancelled', label: 'Force Cancelled' },
  { key: 'forcePendingLive', label: 'Force Pending Live' },
  { key: 'forcePendingCancel', label: 'Force Pending Cancel' },
];

const SelectionHeader = ({
  selections,
  selectedIndex,
  onSelectionChange,
  onOpenSetDates,
  onReset,
  isBusy,
  onApplyPreset,
  onCancelAndUnmatch,
}) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
      <TextField
        select
        size="small"
        label="Selection"
        value={selectedIndex}
        onChange={(event) => onSelectionChange(Number(event.target.value))}
        fullWidth
      >
        {selections.map((selection, index) => (
          <MenuItem key={selection.id || index} value={index}>
            {selection.productDescription || selection.serviceItemName || `Selection ${index + 1}`} -{' '}
            {selection.status || selection.productSelectionStatus || 'Unknown'}
          </MenuItem>
        ))}
      </TextField>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          mt: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Button variant="outlined" size="small" onClick={onOpenSetDates}>
            Set dates...
          </Button>
          <Typography variant="body2" color="text.secondary">
            Billing / Selection / Effective
          </Typography>
        </Box>
        <Button
          variant="outlined"
          color="inherit"
          size="small"
          onClick={onReset}
          disabled={isBusy}
          data-testid="sendtab-reset"
        >
          Reset
        </Button>
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2 }}>
        {QUICK_ACTIONS.map((action) => (
          <Button key={action.key} variant="outlined" size="small" onClick={() => onApplyPreset(action.key)}>
            {action.label}
          </Button>
        ))}
        <Button variant="outlined" size="small" onClick={onCancelAndUnmatch}>
          Cancel &amp; Unmatch
        </Button>
      </Box>
    </Paper>
  );
};

export default SelectionHeader;
